import { useBMTheme } from '../../theme';
import { useLocale } from './context';
const useLocalization = () => {
    const { country } = useLocale();
    const { BMComponents } = useBMTheme();
    let localizationConfig;
    switch (country) {
        case 'jp':
            localizationConfig = {
                firstDay: 'sun',
                dayColor: {
                    6: BMComponents.BMUiCalendarInkDateWeekend,
                },
            };
            break;
        case 'kr':
            localizationConfig = {
                firstDay: 'sun',
                dayColor: {
                    6: BMComponents.BMUiCalendarInkDateWeekend,
                },
            };
            break;
        default:
            localizationConfig = {
                firstDay: 'mon',
                dayColor: {},
            };
            break;
    }
    return { ...localizationConfig };
};
export default useLocalization;
